<template>
  <div>
    <SearchForm @searchUser="searchUser" @searchReset="searchReset" />

    <div v-if="searchAccount">
      <UserInfo :account="searchAccount.user" />
      <Balance v-if="searchAccount.user.status !== 'deleted'" :account="searchAccount.user" />
      <div>
        <b-tabs content-class="mt-3">
          <b-tab title="Activations" active><Activations /></b-tab>
          <b-tab title="Purchases"><Purchases /></b-tab>
          <b-tab title="Reports">
            <Reports ref="reportsRef" :uid="searchAccount.user.fbuid" />
          </b-tab>
          <b-tab title="Support Notes"><Notes /></b-tab>
          <b-tab title="Status Change History"><StatusChangeHistory /></b-tab>
          <b-tab title="KYC"><KYC :account="searchAccount.user" /></b-tab>
        </b-tabs>
      </div>
    </div>
    <div v-if="searchData && searchData.length > 1">
      <AccountsList :accounts="searchData" />
    </div>
  </div>
</template>

<script>
import { useSearch } from '@/use/search'
import SearchForm from '@/components/SearchForm'
import UserInfo from '@/components/UserInfo'
import Balance from '@/components/Balance'
import Purchases from '@/components/Purchases'
import Reports from '@/components/Reports/Index'
import Activations from '@/components/Activations'
import Notes from '@/components/Notes/List'
import StatusChangeHistory from '@/components/StatusChangeHistory/List'
import KYC from '@/components/KYC'
import AccountsList from '@/components/AccountsList'

export default {
  components: {
    SearchForm,
    UserInfo,
    Balance,
    Purchases,
    AccountsList,
    Activations,
    Reports,
    Notes,
    StatusChangeHistory,
    KYC
  },
  computed: {
    searchData() {
      return this.$store.state.search.searchData
    },
    searchAccount() {
      return this.$store.state.search.searchAccount
    }
  },
  setup() {
    const { getSearchData } = useSearch()
    return { getSearchData }
  },
  methods: {
    async searchUser(uid, email, orderId, activationData) {
      if (!uid && !email && !orderId && !activationData) {
        this.$store.commit('alert/add', {
          id: Date.now(),
          text: 'Please input UserId, Email, OrderId, ActivationId or Number',
          timeout: 2000,
          name: 'empty_search_warning'
        })
        return
      }
      try {
        this.$store.commit('loaders/setSearchLoading', true)
        await this.getSearchData(uid, email, orderId, activationData)
        if (this.$refs.reportsRef) {
          await this.$refs.reportsRef.getReportsData()
        }
        this.$store.commit('loaders/setSearchLoading', false)
      } catch (e) {
        console.log(e)
      }
    },
    searchReset() {
      this.$store.commit('search/setSearchData', null)
    }
  }
}
</script>
